export default __webpack_public_path__ + "static/media/amex.dbbfcd02.svg";